<!-- ══════════════════════════════════════════════
   PRELOADER — Light theme, animated logo
══════════════════════════════════════════════ -->
<div class="pre-loader" [class.pre-loader--hidden]="isHidden">

  <!-- Background decoration -->
  <div class="pre-bg">
    <div class="pre-bg-blob pre-bb1"></div>
    <div class="pre-bg-blob pre-bb2"></div>
    <div class="pre-bg-blob pre-bb3"></div>
    <div class="pre-bg-grid"></div>
  </div>

  <!-- Floating sparkles -->
  <ul class="pre-sparks" aria-hidden="true">
    <li class="ps ps1"></li>
    <li class="ps ps2"></li>
    <li class="ps ps3"></li>
    <li class="ps ps4"></li>
    <li class="ps ps5"></li>
    <li class="ps ps6"></li>
    <li class="ps ps7"></li>
    <li class="ps ps8"></li>
    <li class="ps ps9"></li>
    <li class="ps ps10"></li>
  </ul>

  <!-- ── Main centred block ── -->
  <div class="pre-center">

    <!-- Logo + rings -->
    <div class="pre-logo-stage">
      <!-- Outermost dashed ring -->
      <div class="pre-ring pre-r0"></div>
      <!-- Spinning arcs -->
      <div class="pre-ring pre-r1"></div>
      <div class="pre-ring pre-r2"></div>
      <div class="pre-ring pre-r3"></div>
      <!-- Glow halo (not spinning) -->
      <div class="pre-halo"></div>

      <!-- Logo disc -->
      <div class="pre-disc">
        <img [src]="logoUrl || 'assets/img/ACPS_LOGO.png'" alt="School Logo" class="pre-logo-img">
      </div>

      <!-- Orbiting dot -->
      <div class="pre-orbit-track">
        <div class="pre-orbit-dot"></div>
      </div>
    </div>

    <!-- Text block -->
    <div class="pre-text-block">
      <p class="pre-tagline">
        <span class="pre-tl-dot"></span>
        Excellence &nbsp;·&nbsp; Discipline &nbsp;·&nbsp; Integrity
        <span class="pre-tl-dot"></span>
      </p>

      <!-- Animated progress bar -->
      <div class="pre-bar-track">
        <div class="pre-bar-fill"></div>
        <div class="pre-bar-shine"></div>
      </div>

      <!-- Loading label -->
      <div class="pre-loading-label">
        <span class="pre-loading-text">Loading</span>
        <span class="pre-dot pd1">.</span>
        <span class="pre-dot pd2">.</span>
        <span class="pre-dot pd3">.</span>
      </div>
    </div>

  </div><!-- /pre-center -->

  <!-- Corner flourishes -->
  <div class="pre-corner pre-corner-tl"></div>
  <div class="pre-corner pre-corner-tr"></div>
  <div class="pre-corner pre-corner-bl"></div>
  <div class="pre-corner pre-corner-br"></div>

</div>
